
export function createGeneralData(generalDataRepository, generalData) {
  return generalDataRepository.save(generalData);
}